<!-- prettier-ignore -->

<div class="confirm-box-container" [ngClass]="{'expand-confirm-box': itemToAdd()}">
    <div class="info-text">
        @if(itemToAdd()?.item?.status === false){
            <p>{{ 'Este recurso se encuentra fuera de horario' | translate }}</p>
        } 
        <p>{{ '¿Quieres añadir' | translate }} {{itemToAdd()?.item?.name?.[translate.currentLang]}} {{'a la ruta?' | translate }}</p>
    </div>

    <div class="confirm-box-container__button-container">
        <button (click)="cancel()" class="cancel">{{ 'Cancelar' | translate }}</button>
        <button (click)="confirm()" class="confirm">{{ 'Aceptar' | translate }}</button>
    </div>
</div>